import React, { useState } from 'react'
import Modal from 'react-modal'

function InlineTip(props) {
  const [modalIsOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <>
      <button className='tooltip inline' onClick={openModal}>{props.label}</button>

      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={closeModal}
        className='inline-tip-modal'
      >
        <div className='description' dangerouslySetInnerHTML={{ __html: props.content }}/>
        {typeof props.button === 'string' ? <footer>
          <button onClick={() => closeModal()}>{props.button}</button>
        </footer> : null}
      </Modal>
    </>
  )
}

export default InlineTip
